export * from './purchase-of-alarm-approval.component';